import JsBaseComponentAPI from './component';

const JsBase = function (options) {
    this._init(options);
};

JsBase.data = '__jsbase__';

JsBaseComponentAPI(JsBase);

export default JsBase;
